module.exports = "/img/insights.png?e895808dc5c485a08a2ffd7b445487db";